import React from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { Card } from '@thd-olt-component-react/core-ui';
import { SpecialBuyBanner } from '@thd-olt-component-react/special-buy-banner';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

const SpecialBuyOfTheWeekPropTypes = {
  id: string,
};

const SpecialBuyOfTheWeekDefaultProps = {
  id: undefined,
};

export function CustomRenderedSpecialBuyOfTheWeek({
  SCROLL_BUFFER,
  PLACEHOLDER,
}) {
  function SpecialBuyOfTheWeek({ id }) {
    return (
      <QueryProvider cacheKey={`${id}-sbotw`}>
        <Hydrator
          id={`${id}-php-hydrator`}
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          placeholder={PLACEHOLDER}
        >
          <Card>
            <SpecialBuyBanner specialBuyType="pro" />
          </Card>
        </Hydrator>
      </QueryProvider>
    );
  }

  SpecialBuyOfTheWeek.propTypes = SpecialBuyOfTheWeekPropTypes;
  SpecialBuyOfTheWeek.defaultProps = SpecialBuyOfTheWeekDefaultProps;

  return SpecialBuyOfTheWeek;
}
